function waitUntil(evaluate, interval = 200, timeout = -1) {
  let handler;
  const promise = new Promise((resolve, reject) => {
    const start = Date.now();
    handler = setInterval(() => {
      const value = evaluate();
      if (value != null) {
        resolve(value);
        clearInterval(handler);
      } else if (timeout > 0 && Date.now() - start > timeout) {
        reject(new Error("Timeout"));
        clearInterval(handler);
      }
    }, interval);
  });
  return {
    promise,
    cancel: () => {
      handler != null && clearInterval(handler);
    }
  };
}
export {
  waitUntil
};
